export default class LoggerHelper {
    public static error(e) {
        console.error(e);
    }
}